module.exports = __webpack_public_path__ + "img/news2.72149a62.png";